// extracted by mini-css-extract-plugin
var _1 = "ApplicantFitCheckBlockBreakdown-moduleApplicantFitCheckBlockBreakdown__KrE_j";
var _2 = "ApplicantFitCheckBlockBreakdown-modulecolumnTitle__xVO_i";
var _3 = "ApplicantFitCheckBlockBreakdown-moduleexcluded__HDfR0";
var _4 = "ApplicantFitCheckBlockBreakdown-modulefooter__DSIGy";
var _5 = "ApplicantFitCheckBlockBreakdown-moduleformula__GEqCh";
var _6 = "ApplicantFitCheckBlockBreakdown-modulenumeral__xplmm";
var _7 = "ApplicantFitCheckBlockBreakdown-modulerow__zOaAD";
var _8 = "ApplicantFitCheckBlockBreakdown-moduletotal__jRJtT ApplicantFitCheckBlockBreakdown-modulerow__zOaAD";
export { _1 as "ApplicantFitCheckBlockBreakdown", _2 as "columnTitle", _3 as "excluded", _4 as "footer", _5 as "formula", _6 as "numeral", _7 as "row", _8 as "total" }
